import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import Icon from '../Icon';

import BigNumberGraph from './BigNumberGraph';
import LineGraph from './LineGraph';
import ListGraph from './ListGraph';
import BlockGraph from './BlockGraph';
import './style.scss';

export default class Graph extends React.Component {
	static propTypes = {
		data: PropTypes.object,
		title: PropTypes.string,
		more: PropTypes.string,
		loader: PropTypes.node
	};

	getGraph() {
		const { data } = this.props;
		if ((!data.data && data.data !== 0) || (data.type === 'line' && !data.data[0])) {
			return (
				this.props.loader || (
					<div style={{ padding: 20, paddingTop: 25, fontSize: 13, color: '#ccc', textAlign: 'center' }}>
						No data available yet.
					</div>
				)
			);
		}

		switch (data.type) {
		case 'count':
		case 'number':
			return <BigNumberGraph data={data} />;
		case 'line':
			return <LineGraph data={data} />;
		case 'list':
		case 'table':
			return <ListGraph data={data} />;
		case 'block':
			return <BlockGraph data={data} />;
		default:
			return null;
		}
	}

	render() {
		const { data, title, more } = this.props;
		if (!data) {
			return null;
		}

		return (
			<div className="insights-graphs-container">
				{data.totalTitle ? null : (
					<div className="title-container">
						<div className="left">
							<div className="title">{title || data.title}</div>
							{data && data.subtitle && data.subtitle.length ? (
								<div className="info-icon">
									<Icon>info</Icon>
									<div className="right">
										{data.subtitle}
										<i />
									</div>
								</div>
							) : null}
						</div>
						{more ? (
							<div className="right">
								<NavLink to={more} className="view-more">
									View more →
								</NavLink>
							</div>
						) : null}
					</div>
				)}
				<div className="content-container">{this.getGraph()}</div>
			</div>
		);
	}
}
